import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import { connect } from 'react-redux';
import dibsCss from 'dibs-css';
import { trackPromoCodeSubmit } from '../../helpers/checkoutTracking';
import { CheckoutPromotionFormLazy } from './CheckoutPromotionFormLazy';
import { useAppDispatch } from '../../reducers/root';
import { setTriggeredErrors } from '../../actions/checkoutUIActions';

const CheckoutMobilePromotionComponent = props => {
    const { viewer, item, transaction, isComputing, trackingSource } = props;
    const { code, isInvalid } = transaction?.promotions?.[0] || {};
    const submittedPromoCode = useRef(null);
    const trackedPromoCode = useRef(null);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!code || trackedPromoCode.current === code || submittedPromoCode.current !== code) {
            return;
        }
        trackPromoCodeSubmit(null, code, { isSuccessful: !isInvalid, source: trackingSource });
        if (isInvalid) {
            dispatch(setTriggeredErrors(['promo-code']));
        }
        trackedPromoCode.current = code;
        submittedPromoCode.current = null;
    }, [code, isInvalid, trackingSource, dispatch]);

    function handlePromoCodeSubmit(newPromoCode) {
        submittedPromoCode.current = newPromoCode;
    }

    return (
        <div className={dibsCss.mtSmall}>
            <FormattedMessage
                id="checkout.CheckoutMobilePromotion.add"
                defaultMessage="Add promo code"
            />
            <CheckoutPromotionFormLazy
                viewer={viewer}
                item={item}
                transaction={transaction}
                isComputing={isComputing}
                isOpen
                onPromoCodeSubmit={handlePromoCodeSubmit}
            />
        </div>
    );
};

CheckoutMobilePromotionComponent.propTypes = {
    viewer: PropTypes.object,
    item: PropTypes.object,
    buyer: PropTypes.object,
    transaction: PropTypes.object,
    promoCode: PropTypes.string.isRequired,
    isComputing: PropTypes.bool.isRequired,
    trackingSource: PropTypes.string,
};

const ConnectedCheckoutMobilePromotion = connect(({ transaction }) => ({
    promoCode: transaction.promoCode || '',
}))(CheckoutMobilePromotionComponent);

export const CheckoutMobilePromotion = createFragmentContainer(ConnectedCheckoutMobilePromotion, {
    viewer: graphql`
        fragment CheckoutMobilePromotion_viewer on Viewer {
            ...CheckoutPromotionForm_viewer
        }
    `,
    item: graphql`
        fragment CheckoutMobilePromotion_item on Item {
            ...CheckoutPromotionForm_item
        }
    `,
    transaction: graphql`
        fragment CheckoutMobilePromotion_transaction on Transaction {
            ...CheckoutPromotionForm_transaction
            promotions {
                code
                isInvalid
            }
        }
    `,
});
